import utils from "../utils";

const observer = {
	elems: {
		anim: document.querySelectorAll(".animate-wrapper .animate"),
	},
	obj: {
		anim: null,
	},
	set: {
		anim: function () {
			observer.obj.anim = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting || entry.intersectionRatio > 0) {
							let inViewEl = entry.target;
							inViewEl.classList.add("animate-play");
							/*
							inViewEl.querySelectorAll(".animate").forEach(
								function (entry) {
								entry.addEventListener('animationend', () => {
									entry.classList.add("animate-ended");
									inViewEl.classList.add("animate-ended");
								});
							});
							*/

							//observer.obj.anim.unobserve(inViewEl);
						}
					});
				},
				{
					rootMargin: "20% 0px -10% 0px",
					threshold: 0.1,
				}
			);
		},
	},
	start: function (elems, type) {
		if (elems.length > 0) {
			if (utils.observerReady) {
				observer.set[type]();
				utils.forEach(elems, function (index, elem) {
					observer.obj[type].observe(elem);
				});
			}
		}
	},
	init: function () {
		var body = document.querySelector("body");
		body.classList.add("page-loaded");

		observer.start(observer.elems.anim, "anim");

		const getVerticalOffset = (el) => {
			let offset = el.offsetTop,
				_el = el;
			while (_el.offsetParent) {
				_el = _el.offsetParent;
				offset += _el.offsetTop;
			}
			return offset;
		};

		function parallaxScroll() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			// Seleziona tutte le immagini parallasse			
			var parallaxImages = document.querySelectorAll(".parallax-image");

			parallaxImages.forEach(function (parallaxImage) {

				var image = parallaxImage.querySelector('figure'),
					initialYPos = getVerticalOffset(parallaxImage),
					imageHeight = parallaxImage.offsetHeight,
					imageTop = initialYPos - imageHeight;

				var imageTransform = -(scrollTop - imageTop) * 0.1;

				image.style.transform = "translateY(" + (imageTransform) + "px)";
			});
		}

		// Aggiungi un ascoltatore per l'evento scroll
		window.addEventListener("scroll", parallaxScroll);
	},
};

export default observer;
